import React from "react";
import styled from "styled-components";
import Envelope from "./Envelope";
import { scrollToApply } from "../InstantCash/anchors";

/**
 * Section 5. Inverse of the other landers' closing panels: a white CTA on ink,
 * with the envelope watermark bleeding off the bottom-left.
 *
 * See Hero.styles.ts for the px-not-rem note.
 */
const Wrapper = styled.section`
  position: relative;
  overflow: hidden;
  background: var(--brand-ink);
  color: #fff;

  /* the mark keeps the envelope's native 4:3 ratio so it is not letterboxed */
  .mark {
    pointer-events: none;
    position: absolute;
    left: -24px;
    bottom: -24px;
    width: 208px;
    height: 160px;
    color: rgba(209, 31, 61, 0.25);

    svg {
      width: 100%;
      height: 100%;
      display: block;
    }
  }

  .inner {
    position: relative;
    margin: 0 auto;
    max-width: 896px;
    padding: 80px 20px;
    text-align: center;
  }

  .heading {
    margin: 0;
    font-family: var(--brand-display);
    font-size: 36px;
    font-weight: 800;
    letter-spacing: -0.025em;
    line-height: 1.1;
    color: #fff;
  }

  .copy {
    margin: 16px auto 0;
    max-width: 576px;
    font-size: 18px;
    line-height: 1.6;
    color: rgba(255, 255, 255, 0.7);
  }

  .cta {
    appearance: none;
    cursor: pointer;
    margin-top: 32px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 56px;
    padding: 0 32px;
    border: none;
    border-radius: 999px;
    background: #fff;
    color: var(--brand-ink);
    font-family: var(--brand-sans);
    font-size: 16px;
    font-weight: 700;
    box-shadow: 0 16px 30px -12px rgba(255, 255, 255, 0.4);
    transition: background 0.35s cubic-bezier(0.4, 0, 0.2, 1);

    &:hover {
      background: var(--brand-bone);
    }

    &:focus-visible {
      outline: 3px solid #fff;
      outline-offset: 3px;
    }
  }

  @media screen and (min-width: 640px) {
    .mark {
      width: 288px;
      height: 224px;
    }
    .inner {
      padding: 80px 32px;
    }
    .heading {
      font-size: 48px;
    }
  }

  @media screen and (min-width: 1024px) {
    .inner {
      padding: 112px 32px;
    }
    .heading {
      font-size: 60px;
    }
  }

  @media screen and (max-width: 480px) {
    .cta {
      width: 100%;
    }
  }
`;

const ClosingCta = () => (
  <Wrapper className="section-lp3-closing">
    <span className="mark" aria-hidden="true">
      <Envelope />
    </span>
    <div className="inner">
      <h2 className="heading">Your offer is waiting.</h2>
      <p className="copy">Check your approval status in about a minute.</p>
      <button type="button" className="cta lp-cta" onClick={scrollToApply}>
        Check my approval status
      </button>
    </div>
  </Wrapper>
);

export default ClosingCta;
